document.addEventListener("turbolinks:load", function() {
    $.tab()
});